import { render, staticRenderFns } from "./agenteia-form.vue?vue&type=template&id=58c418c1"
import script from "./agenteia-form.vue?vue&type=script&lang=js"
export * from "./agenteia-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports